import ReactDOM from "react-dom/client";
// import "./index.css";
import "./assets/scss/index.scss";
import './locals/index'
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { SnackbarProvider } from "notistack";
import { SnackbarUtilsConfigurator } from "./components/NotistackPlus";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { LicenseInfo } from '@mui/x-license-pro';
import "freyads/freyadesignsystem.css";

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY as string)

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <SnackbarProvider
    maxSnack={1}
    anchorOrigin={{ vertical: "top", horizontal: "center" }}
  >
    <SnackbarUtilsConfigurator />
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </SnackbarProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
